import {
  EditedRecord,
  TrackedKeywordPrediction,
} from '@modules/feedback/store/types';
import { FeedbackLabelType } from 'v2/core/entities/feedback';

export const getTrackedKeywordPredictions = (editRecord?: EditedRecord) => {
  return editRecord?.editPredictions?.filter(
    (editPrediction): editPrediction is TrackedKeywordPrediction =>
      editPrediction.type === FeedbackLabelType.Entity,
  );
};
